import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgCloseRoundedDimension = {
  height: 16,
  width: 16,
  viewBox: '0 0 16 16',
};

type SvgCloseRoundedProps = SVGProps<SVGSVGElement> & {
  circleColor?: string;
  crossColor?: string;
};

export const SvgCloseRounded = memo(
  ({ circleColor = 'currentColor', crossColor = '#FFFFFF', ...props }: SvgCloseRoundedProps) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <circle cx={8} cy={8} r={8} fill={circleColor} />
      <path
        d="M5.6 5.6L10.4 10.4M10.4 5.6L5.6 10.4"
        stroke={crossColor}
        strokeWidth={1.3}
        strokeLinecap="round"
      />
    </svg>
  )
);
